import React, { useState } from 'react';
import {
  Phone,
  MessageSquare,
  Mail,
  X,
  Clock,
  MapPin
} from 'lucide-react';

const FloatingContactOptions: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const contactOptions = [
    {
      icon: Phone,
      label: 'Call Us',
      action: () => window.open('tel:+917795006081'),
      color: 'bg-green-500 hover:bg-green-600',
      description: '+91 77950 06081'
    },
    {
      icon: MessageSquare,
      label: 'WhatsApp',
      action: () =>
        window.open(
          'https://wa.me/917795006081?text=Hi, I want to know more about SAP S4HANA courses at ShreeGuruCool'
        ),
      color: 'bg-green-600 hover:bg-green-700',
      description: 'Chat on WhatsApp'
    },
    {
      icon: Mail,
      label: 'Email',
      action: () =>
        window.open(
          'mailto:shreegurucool@gmail.com?subject=Inquiry about SAP S4HANA Courses'
        ),
      color: 'bg-blue-500 hover:bg-blue-600',
      description: 'Send Email'
    }
  ];

  return (
    <div className="fixed bottom-6 left-6 z-50">
      {/* Expanded Contact Options */}
      {isExpanded && (
        <div className="mb-4 space-y-4 transition-all duration-300 ease-out">
          {contactOptions.map((option, index) => (
            <div
              key={index}
              className="flex items-center gap-3 animate-fade-in-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="bg-white shadow-md border rounded px-3 py-1 text-sm text-gray-700 max-w-[160px]">
                {option.description}
              </div>
              <button
                onClick={option.action}
                className={`${option.color} text-white p-3 rounded-full shadow-lg hover:shadow-xl transition transform hover:scale-110`}
                title={option.label}
              >
                <option.icon className="h-5 w-5" />
              </button>
            </div>
          ))}

          {/* Info Card */}
          <div className="bg-white shadow-md border rounded-lg p-4 w-[250px] text-sm text-gray-700">
            <h3 className="font-semibold text-gray-900 mb-2">Contact Information</h3>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <Clock className="h-4 w-4 text-blue-600" />
                <span>Mon–Sat: 9:30 AM – 6:30 PM</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-blue-600" />
                <span>Bengaluru, Karnataka</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-blue-600" />
                <span>shreegurucoool@gmail.com</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Toggle Button */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="bg-gradient-to-r from-orange-500 to-orange-600 text-white p-4 rounded-full shadow-xl relative transition hover:scale-105"
        title={isExpanded ? 'Close' : 'Contact Us'}
      >
        {isExpanded ? <X className="h-6 w-6" /> : <Phone className="h-6 w-6" />}
        {!isExpanded && (
          <span className="absolute top-0 right-0 w-3 h-3 bg-green-400 rounded-full animate-ping"></span>
        )}
      </button>
    </div>
  );
};

export default FloatingContactOptions;
